<template>
    <v-container pa-0 class="text-center" v-if="confirmation.headline && confirmation.description">
        <v-card tile flat class="pa-2 mt-2">
            <h1 class="headline font-weight-bold success--text mb-2">{{ $vuetify.lang.t(confirmation.headline) }}</h1>
            <p class="body-1 mb-2">
                {{ confirmation.description }}
            </p>
            <v-btn color="primary"
                   :to="confirmation.buttonUrl">
                {{ $vuetify.lang.t(confirmation.button) }}
            </v-btn>
        </v-card>
    </v-container>
</template>
<script>
    // 3rd
    import { mapGetters } from 'vuex';

    // utils
    import { setPageTitle } from '../utils/helper';

    export default {
        name: 'confirmation',
        computed: {
            ...mapGetters('confirmation', [
                'confirmation',
            ]),
        },
    }
</script>
